import GoingWentList from '../components/GoingWentList';
import Layout from '../components/Layout';

export default function MyShowsPage() {
  return (
    <Layout>
      <GoingWentList isPageLevel />
    </Layout>
  );
}
